<div
    (clickOutside)="closeSortOptionDropdown()"
    [attachOutsideOnClick]="true"
>
    <div
        class="agpr-sortOrder-splitButton"
        [ngClass]="{
            'agpr-sortOrder-splitButton--socialPlus': style === agprComponentStyle.socialPlus
        }"
    >
        <button
            pButton
            class="agpr-sortOrder-splitButtonOrder"
            [id]="id + '.sortOrder.splitButtonOrder'"
            [icon]="sortOrderIcon"
            (click)="toggleSortOrder()"
            [disabled]="isDisabled"
            agprTooltip="Monitoring.result.sortMentions"
            tooltipPosition="top"
        ></button>
        <button
            #trigger
            pButton
            class="agpr-sortOrder-splitButtonDropdown"
            [ngClass]="{'agpr-sortOrder-splitButtonDropdown--withLabel': showSelectedSortOrderLabel}"
            [id]="id + '.sortOrder.splitButtonDropdown'"
            [icon]="arrowIcon"
            [label]="showSelectedSortOrderLabel ? (selectedSortOrderLabel | localize) : ''"
            iconPos="right"
            [attr.aria-label]="'Monitoring.result.toggleSortOrderMenu' | localize"
            [attr.aria-expanded]="sortOrderDropdownDisplay"
            [attr.aria-controls]="id + '-sortOrder-listbox'"
            (keydown)="onTriggerKeydown($event)"
            (keyup)="$event.stopPropagation()"
            (click)="sortOrderDropdownClick()"
            [disabled]="isDisabled"
            [agprTooltip]="'Discover.accessibility.sortOrder.sortOrderDropdown' | localize"
            tooltipPosition="top"
        ></button>
    </div>
    <ul
        *ngIf="sortOrderDropdownDisplay"
        role="listbox"
        [id]="id + '-sortOrder-listbox'"
        class="agpr-sortOrder-dropdownPanelItems"
        agprListKeyboardNavigation
    >
        <li
            *ngFor="let item of sortByOptions; let i = index"
            role="option"
            [id]="id + '.sortOrder.dropdownItems_' + i"
            class="agpr-sortOrder-dropdownPanelItem"
            [ngClass]="{ 'agpr-sortOrder-dropdownPanelItem--selected': item.id == selectedMenuItem }"
            [attr.aria-selected]="item.id == selectedMenuItem"
            tabindex="-1"
            (keydown)="onOptionKeydown($event, i)"
            (keyup)="$event.stopPropagation()"
            (click)="item.command()"
        >
            <span>{{ labels[item.id][sortOrder] | localize }}</span>
        </li>
    </ul>
</div>
